import { NgModule } from "@angular/core";

import { GreekToLatinCharactersInputValueDirective } from "./greek-to-latin-characters-input-value.directive";

const DIRECTIVES = [GreekToLatinCharactersInputValueDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class GreekToLatinInputValueModule {}
